import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import i18nMessages from './__i18n__';
import { colorClassName } from '../../../utils/shopping';
import classNames from 'classnames';
import Link from 'react-router/lib/Link';

// Used for the sort filter, which has static labels
const format = (name, intl, messages = i18nMessages()) =>
  name in messages
    ? intl.formatMessage(messages[name])
    : name;

export const ProductListDropdownItem = ({
  handleClick,
  id,
  intl,
  label,
  name,
  path,
  shouldBeSelected
}) => (
  <li>
    <span className={classNames({ selected: shouldBeSelected })}>
      <Link to={path}
        onClick={handleClick}
        className={
          colorClassName(name, label)
        }
        data-id={id}
        data-label={label}
        data-name={name}
        tabIndex="0"
        dangerouslySetInnerHTML={{ __html: format(name, intl) }}
      />
    </span>
  </li>
);

ProductListDropdownItem.propTypes = {
  handleClick: PropTypes.func,
  id: PropTypes.number,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  path: PropTypes.string,
  shouldBeSelected: PropTypes.bool
};

export default injectIntl(ProductListDropdownItem);
